import d from "react";
import { createStylesContext as i, forwardRef as n, useMultiStyleConfig as m, Box as c, useTheme as C } from "@chakra-ui/react";
const [u, o] = i("CardStyle"), y = n(
  ({ children: e, variant: t, ...a }, r) => {
    const s = m("Card", {
      variant: t
    });
    return /* @__PURE__ */ d.createElement(c, { __css: s.card, ...a, ref: r, "data-testid": "card" }, /* @__PURE__ */ d.createElement(u, { value: s }, e));
  }
);
y.displayName = "Card";
const f = n(
  ({ children: e, ...t }, a) => {
    const r = o();
    return /* @__PURE__ */ d.createElement(c, { __css: r.media, ref: a, ...t, "data-testid": "card-media" }, e);
  }
);
f.displayName = "CardMedia";
const _ = n(
  ({ children: e, ...t }, a) => {
    const r = o(), {
      text: { default: s }
    } = C(), l = { ...r.content, color: s };
    return /* @__PURE__ */ d.createElement(c, { __css: l, ref: a, ...t, "data-testid": "card-content" }, e);
  }
);
_.displayName = "CardContent";
export {
  y as Card,
  _ as CardContent,
  f as CardMedia
};
